export const ADD_GROUP = 'ADD_GROUP';
export const REMOVE_GROUP = 'REMOVE_GROUP';
export const SET_CONJUNCTION = 'SET_CONJUNCTION';

export const ADD_RULE = 'ADD_RULE';
export const REMOVE_RULE = 'REMOVE_RULE';
export const SET_FIELD = 'SET_FIELD';
export const SET_OPERATOR = 'SET_OPERATOR';
export const SET_VALUE = 'SET_VALUE';
export const SET_OPERATOR_OPTION = 'SET_OPERATOR_OPTION';
export const SET_VALUE_OPTION = 'SET_VALUE_OPTION';

export const SET_TREE = 'SET_TREE';



// WEBPACK FOOTER //
// ../react-query-builder/src/constants.js